import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { gridQueryKey } from './useGrid'
import { gridsQueryKey } from './useGrids'
import { gridVersionsQueryKey } from './useGridVersions'

import type { Grid, GridVersion } from 'honeygrid-types'

interface PromoteGridVersionParams {
	workspaceId?: string
	gridId: Grid['uuid']
	versionId: GridVersion['uuid']
}

export const usePromoteGridVersion = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const { organization } = useStytchOrganization()

	return useMutation({
		mutationFn: ({ gridId, versionId }: PromoteGridVersionParams) =>
			authFetch(
				`workspaces/${organization?.organization_id}/grids/${gridId}/versions/${versionId}/promote`,
				{
					method: 'POST',
				}
			) as Promise<GridVersion>,
		onSuccess: (_, { gridId }) => {
			// Invalidate grids list for workspace
			queryClient.invalidateQueries({ queryKey: gridsQueryKey(organization?.organization_id) })
			// Invalidate specific grid details (affects currentVersion)
			queryClient.invalidateQueries({
				queryKey: gridQueryKey(organization?.organization_id ?? '', gridId),
			})
			// Invalidate grid versions
			queryClient.invalidateQueries({
				queryKey: gridVersionsQueryKey(organization?.organization_id ?? '', gridId),
			})
		},
	})
}
